import axios from 'axios'

const showOnlineBalanceOrders = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}systemUsers/onlineBalanceOrders`,
      {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )

    return response.data.data
  } catch (error) {}
}

export default showOnlineBalanceOrders
